import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { putCustomerOrderChargesInfoUpdate } from "../../services/OrderEdit/orderInfoEdit";
import { getCustomerSingleOrderInfo } from "../../services/OrdersAPI/Orders";

const BookingInfoDiscountsEdit = ({
  bookingInfoChargesEditModalVisible,
  setBookingInfoChargesEditModalVisible,
  sendDataToBookingInfoChargesEdit,
  storeCustomerId,
  bookingOrderId,
  storeId,
  discountAmountPreviousValue,
}) => {
  const [selectedDiscountAmount, setSelectedDiscountAmount] = useState('');
  const [selectedDiscountAmountPrevious, setSelectedDiscountAmountPrevious] = useState(0);

  const [customerOrdersData,setCustomerOrdersData] = useState([])

  const fetchCustomerSingleOrder = () => {
    // getCustomerSingleOrder(storeCustomerId, storeId, bookingOrderId)
    getCustomerSingleOrderInfo(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerOrdersData(Res);
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });

    }

  useEffect(() => {
    // Check if selectedPackageItemValue is available
    fetchCustomerSingleOrder();
    const discountAmountValue =
      discountAmountPreviousValue?.amount?.toFixed(0);
    setSelectedDiscountAmount(discountAmountValue?.toString());
    setSelectedDiscountAmountPrevious(discountAmountValue);
  }, [discountAmountPreviousValue, bookingInfoChargesEditModalVisible]);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState('');
  const [errorText, setErrorText] = useState('');


  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [showUpdateButton, setShowUpdateButton] = useState(false);


  const handleDiscountAmountChange = text => {
    if (!text) {
      setSelectedDiscountAmount('');
      setErrorText('Discount cannot be empty or zero');
      setIsSubmitButtonPressed(true);
    } 
    else {
      if(text > (parseInt(customerOrdersData.grandTotal) + parseInt(selectedDiscountAmountPrevious))) {
        setSelectedDiscountAmount("");
        setErrorText('Discount cannot be Greater Than ' + (parseInt(customerOrdersData.grandTotal) + parseInt(selectedDiscountAmountPrevious)));
        setIsSubmitButtonPressed(false);
      } else {
        setSelectedDiscountAmount(text);
        setErrorText('');
        setIsSubmitButtonPressed(false);
      }
    }
  };


  const handleConfirmation = () => {
    if (!errorText) {
      setIsSubmitButtonPressed(true);
      const data = {
        ...discountAmountPreviousValue,
        amount: parseInt(selectedDiscountAmount),
      };


      putCustomerOrderChargesInfoUpdate(
        storeCustomerId,
        storeId,
        bookingOrderId,
        data,
      )
        .then(response => {
          if (!response.data.error) {
            const Res = response.data;
            const message = Res.message;
            const status = Res.status;
            sendDataToBookingInfoChargesEdit({
              success: status,
            });
            setIsSubmitButtonPressed(false);
            setBookingInfoChargesEditModalVisible(false);
            setSelectedDiscountAmount("");
          }
        })
        .catch(err => {
          console.error('Error:', err);
        });
    }
    setShowUpdateButton(true);
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
          setBookingInfoChargesEditModalVisible(false);
          setErrorText('');
          setShowUpdateButton(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={bookingInfoChargesEditModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!bookingInfoChargesEditModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
          className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
             <div>
                <div  className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
                  style={{
                    backgroundImage:
                      "radial-gradient(circle at left top, #2B70D7, #1752AA)",
                  }}>
                  <div></div>

                  <p className=" text-4xl text-primary-50 font-semibold">
                    Discount Amount
                  </p>
                  <Button
                    label="x"
                    onClick={(e) => hide(e)}
                    text
                    className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
                  ></Button>
                </div>

                <div className="mt-3 mx-4">
                  <div className="flex flex-row justify-content-center">
                    <div>
                      <p className=" text-xl font-semibold">Discount</p>
                    </div>
                  </div>
                </div>
                <div className="mt-2 mb-2 mx-4">
                  <div className="flex flex-row justify-content-center gap-4">
                  <div className="border-round-xl shadow-4">
                      <InputText
                        placeholder="amount"
                        value={selectedDiscountAmount}
                        maxLength={50}
                        onChange={(e) =>
                          handleDiscountAmountChange(e.target.value)
                        }
                        className="w-full border-none px-3 text-md "
                      ></InputText>
                    </div>
                  </div>
                </div>

                {errorText && (
                  <div
                    style={{
                      marginTop: 2,
                      marginBottom: 10,
                      marginLeft:40,
                      alignSelf: "center",
                    }}
                  >
                    <p style={{color:"red"}}>{errorText}</p>
                  </div>
                )}
              </div>

             
                <Button
                   
                  disabled={isSubmitButtonPressed}
                  onClick={handleConfirmation}
                   
                  className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  Update
                </p></Button>
             
            
          </div>
        )}
      ></Dialog>
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default BookingInfoDiscountsEdit;
